module.exports = __webpack_public_path__ + "img/68.7e9cff1a.png";